import printJS from "print-js";
import { api_URL } from "../constantes/BaseURL";


export const printPDF = (url) => {

    printJS({
        printable: `${api_URL}` + url,
        type: 'pdf',
        onPdfOpen: true,
        fallbackPrintable: true
        // showModal: true,
        // modalMessage: 'Chargement en cours'
    });

};

